/* global axios */
import ApiClient from './ApiClient';

class LabelContactBulkOperationsAPI extends ApiClient {
  constructor() {
    super('label_contact_bulk_operations', { accountScoped: true });
  }

  // GET /labels/:labelId/contact_bulk_operations/preview?action_type=...
  preview({ labelId, action }) {
    return axios.get(
      `${this.baseUrl()}/labels/${labelId}/contact_bulk_operations/preview`,
      { params: { action_type: action } }
    );
  }

  // POST /labels/:labelId/contact_bulk_operations { action_type }
  create({ labelId, action }) {
    return axios.post(
      `${this.baseUrl()}/labels/${labelId}/contact_bulk_operations`,
      { action_type: action }
    );
  }

  // GET /label_contact_bulk_operations
  list(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new LabelContactBulkOperationsAPI();
